<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="CompensatoryOffPoliciesForm" (ngSubmit)="Validate(CompensatoryOffPoliciesForm)"
        #CompensatoryOffPoliciesForm="ngForm" novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Compensatory Off Policy
                </div>
                <div class="card-body ms-5">
                    <div class="row mb-3">
                        <div class="col-md-2 align-self-center">
                            <label for="CompOffRuleName" class="form-label text-label-dark">Policy Name :</label>
                        </div>
                        <div class="col-md-5">
                            <input type="text" class="form-control text-label-light" placeholder="Ex. Policy Name"
                                id="CompOffRuleName" name="CompOffRuleName"
                                [(ngModel)]="CompensatoryOff.CompOffRuleName" #CompOffRuleName="ngModel" maxlength="100"
                                required>
                            <div class="invalid-feedback">
                                Please Enter Policy Name!
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Compensatory Off can be raised for :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-auto mt-1">
                            <div class="btn-group">
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="FullDay" name="FullDay"
                                        [(ngModel)]="CompensatoryOff.CompOffRaiseFor">
                                    <label class="form-check-label text-label-light" for="FullDay">
                                        Full Day
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="HalfDay" name="HalfDay"
                                        [(ngModel)]="CompensatoryOff.CompOffRaiseFor">
                                    <label class="form-check-label text-label-light" for="HalfDay">
                                        Half Day
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Make Reason Mandatory :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="ReasonMandatory"
                                        [(ngModel)]="CompensatoryOff.ReasonMandatory"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="ReasonMandatory"
                                        [(ngModel)]="CompensatoryOff.ReasonMandatory"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Compensatory Off can be raised only on :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col">
                            &nbsp;&nbsp;&nbsp; <div class="btn-group btn-group-toggle">
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsCompOffOnAllDay"
                                        name="IsCompOffOnAllDay" [(ngModel)]="CompensatoryOff.IsCompOffOnAllDay"
                                        (change)="CheckAll()">
                                    <label class="form-check-label text-label-light" for="IsCompOffOnAllDay">
                                        All day
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsCompOffOnRegularDay"
                                        name="IsCompOffOnRegularDay" [(ngModel)]="CompensatoryOff.IsCompOffOnRegularDay"
                                        [disabled]="CompensatoryOff.IsCompOffOnAllDay">
                                    <label class="form-check-label text-label-light" for="IsCompOffOnRegularDay"
                                        [ngClass]="{'clicklock':CompensatoryOff.IsCompOffOnAllDay}">
                                        Regular day
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsCompOffOnHoliday"
                                        name="IsCompOffOnHoliday" [(ngModel)]="CompensatoryOff.IsCompOffOnHoliday"
                                        [disabled]="CompensatoryOff.IsCompOffOnAllDay">
                                    <label class="form-check-label text-label-light" for="IsCompOffOnHoliday"
                                        [ngClass]="{'clicklock':CompensatoryOff.IsCompOffOnAllDay}">
                                        Holiday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsCompOffOnWeekOff"
                                        name="IsCompOffOnWeekOff" [(ngModel)]="CompensatoryOff.IsCompOffOnWeekOff"
                                        [disabled]="CompensatoryOff.IsCompOffOnAllDay">
                                    <label class="form-check-label text-label-light" for="IsCompOffOnWeekOff"
                                        [ngClass]="{'clicklock':CompensatoryOff.IsCompOffOnAllDay}">
                                        Week-off
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">CompOff allowed on following week days :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col">
                            <div class="btn-group btn-group-toggle">
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsSunday" name="IsSunday"
                                        [(ngModel)]="CompensatoryOff.IsSunday">
                                    <label class="form-check-label text-label-light" for="IsSunday">
                                        Sunday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsMonday" name="IsMonday"
                                        [(ngModel)]="CompensatoryOff.IsMonday">
                                    <label class="form-check-label text-label-light" for="IsMonday">
                                        Monday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsTuesday" name="IsTuesday"
                                        [(ngModel)]="CompensatoryOff.IsTuesday">
                                    <label class="form-check-label text-label-light" for="IsTuesday">
                                        Tuesday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsWednesday" name="IsWednesday"
                                        [(ngModel)]="CompensatoryOff.IsWednesday">
                                    <label class="form-check-label text-label-light" for="IsWednesday">
                                        Wednesday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsThursday" name="IsThursday"
                                        [(ngModel)]="CompensatoryOff.IsThursday">
                                    <label class="form-check-label text-label-light" for="IsThursday">
                                        Thursday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsFriday" name="IsFriday"
                                        [(ngModel)]="CompensatoryOff.IsFriday">
                                    <label class="form-check-label text-label-light" for="IsFriday">
                                        Friday
                                    </label>
                                </div>
                                <div class="form-check mx-2">
                                    <input class="form-check-input" type="checkbox" id="IsSaturday" name="IsSaturday"
                                        [(ngModel)]="CompensatoryOff.IsSaturday">
                                    <label class="form-check-label text-label-light" for="IsSaturday">
                                        Saturday
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Credit Leave Expires : </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi"
                                [ngbTooltip]="tooltip.CompoffPolicy.CreditLeaveExpires" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event)" class="form-control text-label-light"
                                    [ngClass]="{'ng-invalid': common.parseFloat(CompensatoryOff.CreditLeaveExpire) > 365}"
                                    class="form-control text-label-light" placeholder="Ex. 01" id="CreditLeaveExpire"
                                    name="CreditLeaveExpire" [(ngModel)]="CompensatoryOff.CreditLeaveExpire"
                                    #CreditLeaveExpire="ngModel" required>
                                <span class="input-group-text" id="basic-limit">day's </span>
                                <div class="invalid-feedback">
                                    Please enter valid day's!
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">(0 days then unlimited)</label>
                        </div>
                    </div> -->

                    <div class="row">
                        <div class="col-md-auto">
                            <label class="form-label text-label-dark">Is CompOff BackDated Allowed :</label>
                            <input class="form-check-input m-2" type="checkbox" id="iscompoffbackdatedallowed"
                                name="iscompoffbackdatedallowed" [(ngModel)]="CompensatoryOff.IsCreditLeaveBefore">
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    class="form-control text-label-light" class="form-control text-label-light"
                                    placeholder="Ex. 01" [disabled]="!CompensatoryOff.IsCreditLeaveBefore"
                                    id="iscompoffbackdateddays" name="CreditLeaveBefore"
                                    [(ngModel)]="CompensatoryOff.CreditLeaveBefore" #iscompoffbackdateddays="ngModel"
                                    required>
                                <span class="input-group-text" id="basic-limit">day's </span>
                                <div class="invalid-feedback">
                                    Please enter valid day's!
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-auto">
                            <label class="form-label text-label-dark">Is CompOff FutureDated Allowed :</label>
                            <input class="form-check-input m-2" type="checkbox" id="iscompofffuturedatedallowed"
                                name="iscompofffuturedatedallowed" [(ngModel)]="CompensatoryOff.IsCreditLeaveAfter">
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <input type="text" maxlength="3" pattern="^[0-9.]*$"
                                    class="form-control text-label-light" class="form-control text-label-light"
                                    placeholder="Ex. 01" [disabled]="!CompensatoryOff.IsCreditLeaveAfter"
                                    id="iscompofffuturedateddays" name="CreditLeaveAfter"
                                    [(ngModel)]="CompensatoryOff.CreditLeaveAfter" #iscompofffuturedateddays="ngModel"
                                    required>
                                <span class="input-group-text" id="basic-limit">day's </span>
                                <div class="invalid-feedback">
                                    Please enter valid day's!
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label class="form-label text-label-dark">Full Day Duration : </label>
                        </div>
                        <div class="col-md-auto">
                            <ngb-timepicker name="Duration" type="time"
                                [(ngModel)]="CompensatoryOff.CompOffFullDayHrObj" #Duration="ngModel"
                                (change)="timeFormate($event,'FullDayDuration')" [ngModelOptions]="{standalone: true}"
                                required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter duration!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-2 align-self-center">
                            <label class="form-label text-label-dark">Half Day Duration : </label>
                        </div>
                        <div class="col-md-auto">
                            <ngb-timepicker name="HalfDayDuration" type="time"
                                [(ngModel)]="CompensatoryOff.CompOffHalfDayHrObj" #HalfDayDuration="ngModel"
                                [ngModelOptions]="{standalone: true}" (change)="timeFormate($event,'HalfDayDuration')"
                                required></ngb-timepicker>
                            <div class="invalid-feedback">
                                Please enter duration!
                            </div>
                        </div>
                        <div class="col-md-auto align-self-center">
                            <label class="form-label text-label-dark">hours</label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"
                                [ngbTooltip]="tooltip.Message24hr"></i>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Validate Shift For Fullday :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="ValidateShiftForFullDay"
                                        [(ngModel)]="CompensatoryOff.ValidateShiftForFullDay"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="ValidateShiftForFullDay"
                                        [(ngModel)]="CompensatoryOff.ValidateShiftForFullDay"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Validate Shift For Halfday :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="ValidateShiftForHalfDay"
                                        [(ngModel)]="CompensatoryOff.ValidateShiftForHalfDay"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="ValidateShiftForHalfDay"
                                        [(ngModel)]="CompensatoryOff.ValidateShiftForHalfDay"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-auto mt-1">
                            <label class="form-label text-label-dark">Allow Request After Monthlock :
                            </label>
                            <i class="bi bi-info-circle-fill ps-2 tooltipi" placement="right"></i>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="CompensatoryOff.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name="AllowRequestAfterMonthlock"
                                        [(ngModel)]="CompensatoryOff.AllowRequestAfterMonthlock"
                                        [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.CompensatoryOff.ESS_CompOffRuleId == 0) || (this.CompensatoryOff.ESS_CompOffRuleId > 0 && common.ToLowerCase(CompensatoryOff.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="CompensatoryOff.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()" [disabled]="CompensatoryOff.ESS_CompOffRuleId > 0"
                                        required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.CompensatoryOff.ESS_CompOffRuleId == 0) || (this.CompensatoryOff.ESS_CompOffRuleId > 0 && common.ToLowerCase(CompensatoryOff.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="CompensatoryOff.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()" [disabled]="CompensatoryOff.ESS_CompOffRuleId > 0"
                                        required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Default Rule :</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name="DefaultRule"
                                        [(ngModel)]="CompensatoryOff.DefaultRule" [ngModelOptions]="{standalone: true}">
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false name="DefaultRule"
                                        [(ngModel)]="CompensatoryOff.DefaultRule" [ngModelOptions]="{standalone: true}">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="CompensatoryOff.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()"
                                        [disabled]="Applicability.WebESSApplicabilityMasterID == 0 && CompensatoryOff.DefaultRule">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && CompensatoryOff.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button
                    *ngIf="(this.common.PageRight.IsAdd && this.CompensatoryOff.ESS_CompOffRuleId == 0) || (this.common.PageRight.IsEdit && this.CompensatoryOff.ESS_CompOffRuleId > 0)"
                    type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>